import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Slider from '@material-ui/lab/Slider';
import Slider from '@material-ui/core/Slider';

import "./CCT.scss";

const useStyles = makeStyles({
  mark: {
    color: '#000000'
  }
});

const marks = [
  {
    value: 30,
    label: "3000K",
  },
  {
    value: 35,
    label: "3500K",
  },
  {
    value: 40,
    label: "4000K",
  }
];

function valuetext(value) {
  return `${value}`;
}

function CCT(props) {
  const classes = useStyles();
  const {configuration,createItem,setNextEnabled} = props;

  if(!configuration["cct"]){
    handleChange(null,30);
  }

  function handleChange(event, value) {
    setNextEnabled(true);
    createItem({id:"cct",value:value + "K"});
  }

  function valueLabelFormat(value){
    return marks[marks.findIndex(mark => mark.value === value)].value + "K";
  }

  return (
    <div className="slider-root">
      <p className="instructions">Choose between 3 correlated color temperatures</p>
      <br/>
      <Slider
        defaultValue={configuration["cct"] ? parseInt(configuration["cct"]) : 30}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider-always"
        step={5}
        min={30}
        max={40}
        marks={marks}
        valueLabelFormat={valueLabelFormat}
        valueLabelDisplay="on"
        onChange={handleChange}
        classes={{markLabel: classes.mark}}
      />
      <div className="gradient"><div>Warm</div><div>Neutral</div><div>Cool</div></div>
    </div>
  );
}

export default CCT;
